module.exports = __webpack_public_path__ + "static/img/u91012.37383ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u91012.jpg
// module id = wztu
// module chunks = 73